import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import './Button.css'

const MotionLink = motion.create(Link)

/**
 * variant: 'primary' | 'secondary' | 'ghost' | 'signal'
 * size: 'sm' | 'md' | 'lg'
 */
export default function Button({
  as,
  to,
  href,
  variant = 'primary',
  size = 'md',
  icon,
  loading = false,
  className = '',
  children,
  ...rest
}) {
  const classes = `ll-btn ll-btn--${variant} ll-btn--${size} ${loading ? 'll-btn--loading' : ''} ${className}`.trim()

  const content = (
    <>
      {icon && <span className="ll-btn__icon">{icon}</span>}
      <span className="ll-btn__label">{children}</span>
    </>
  )

  const motionProps = {
    whileHover: { y: -1 },
    whileTap: { scale: 0.97 },
    transition: { duration: 0.15, ease: [0.16, 1, 0.3, 1] },
  }

  if (to) {
    return (
      <MotionLink to={to} className={classes} {...motionProps} {...rest}>
        {content}
      </MotionLink>
    )
  }

  if (href) {
    return (
      <motion.a href={href} className={classes} {...motionProps} {...rest}>
        {content}
      </motion.a>
    )
  }

  const MotionComponent = motion.create(as ?? 'button')
  return (
    <MotionComponent className={classes} disabled={loading || rest.disabled} {...motionProps} {...rest}>
      {content}
    </MotionComponent>
  )
}
